import { TestimonialModelFragment } from '.generated/dato'
import DatoImage from './DatoImage'
import { Quote } from './Quote'
import { Container } from './Container'
import { cx } from 'lib/cx'

export function Testimonial(props: {
  testimonial: TestimonialModelFragment
  children?: React.ReactNode
  containerClassName?: string
  figureClassName?: string
  quoteClassName?: string
}) {
  return (
    <Container className={props.containerClassName}>
      <figure
        className={cx(
          'rounded-full overflow-hidden w-224 h-224 min-w-224 self-center relative',
          props.figureClassName,
        )}
      >
        <DatoImage
          file={props.testimonial.image}
          fill
          style={{ objectFit: 'contain' }}
          placeholder="blur"
          sizes="224px"
        />
      </figure>
      <Quote
        quote={props.testimonial.quote}
        author={props.testimonial.person}
        className={props.quoteClassName}
      >
        {props.children}
      </Quote>
    </Container>
  )
}
